import * as PlaylistRadioService from 'widget/PlaylistRadio/services';
import baseLogger from 'widget/logger';
import HttpError from 'widget/Errors/HttpError';
import qs from 'qs';
import { getPlaylistIdFromSlug } from 'state/Playlist/helpers';
import {
  InitialProps,
  InstanceMethods,
  PlaylistRadioResolvedProps,
} from 'widget/PlaylistRadio/types';
import { pick } from 'lodash-es';
import { TrackingStationType } from 'widget/types/widgetTrackingConfig';
import { WIDGET_DIMENSIONS } from 'constants/widgetDimensions';
import { WidgetLocationConfig } from 'widget/types';

export default async function getInitialProps(
  { params, query }: InitialProps,
  { logger = baseLogger, transport }: InstanceMethods,
  { api, terminalId = 0, websiteUrl = '' }: WidgetLocationConfig,
): Promise<PlaylistRadioResolvedProps> {
  const { id: urlId } = params;
  const { autoplay } = query;
  const { id, owner } = getPlaylistIdFromSlug(urlId);

  if (!id || !owner)
    throw new HttpError(400, 'playlist id or owner is missing.');

  const playlist = await PlaylistRadioService.fetchPlaylist({
    ampUrl: api.server,
    logger,
    ownerId: owner,
    playlistId: id,
    transport,
  });

  const {
    author,
    description,
    duration,
    id: playlistId,
    name,
    reportingKey,
    slug,
    tracks,
    urls,
    userId,
  } = playlist;

  const trackIds =
    tracks && tracks.length > 0 ? tracks.map(t => t.trackId) : [];

  const playlistTracks = await PlaylistRadioService.fetchPlaylistTracks({
    ampUrl: api.server,
    logger,
    trackIds,
    transport,
  });

  const { image } = urls ?? {};

  // query string parameters for analytics so that we can tell the user came to the playlist radio from widget
  const trackParamsforLandingUrls = {
    keyid: slug,
    pname: 'playlist_radio',
    sc: 'widget_share',
  };

  const basePlaylistRadioUrl =
    `${websiteUrl}/playlist/${slug}-${userId}-${playlistId}`.replace(
      'http://',
      'https://',
    );
  return {
    ampUrl: api.client,
    author,
    autoplay: !!autoplay,
    basePlaylistRadioUrl,
    description,
    dimensions: { ...WIDGET_DIMENSIONS.PLAYLIST },
    duration,
    embedUrl: `${basePlaylistRadioUrl}?${qs.stringify(
      pick(query, ['embed', 'theme']),
    )}`,
    followUrl: `${basePlaylistRadioUrl}?${qs.stringify({
      ...trackParamsforLandingUrls,
      follow: true,
    })}`,
    imageUrl: image?.replace('http://', 'https://'),
    name,
    playlistRadioUrl: `${basePlaylistRadioUrl}/?${qs.stringify(
      trackParamsforLandingUrls,
    )}`,
    reportingKey,
    stationType: TrackingStationType.CUSTOM,
    terminalId,
    trackIds,
    tracks: playlistTracks.slice(0, 5),
    websiteUrl: `${websiteUrl}?${qs.stringify(trackParamsforLandingUrls)}/`,
  };
}
